// NOTE: route name list
const menuCategory = [
  { name: 'booking', list: ['bookings', 'bookingsDetail'] },
  { name: 'hotel', list: ['hotels', 'hotelsDetailInfo', 'hotelsPermission', 'hotelsBookings'] },
  { name: 'doorlock', list: ['doorlocks', 'doorlocksDetailInfo', 'doorlocksMobileKey', 'doorlockLogs', 'doorlockBookings'] },
  { name: 'user', list: ['users', 'usersDetail'] },
  { name: 'staff', list: ['staffs', 'staffsDetail'] },
  { name: 'admin', list: ['admins', 'adminsDetail'] },
  { name: 'domain', list: ['domains', 'domainsDetail'] },
  { name: 'auditLog', list: ['auditLogs', 'auditLogsDetail'] },
];

/**
 * @description route 카테고리 파악
 * @param { Object } route
 * @returns { String } name
 */
function getCategoryName(route) {
  let categoryName = null;
  for (let index = 0; index < menuCategory.length; index += 1) {
    const menu = menuCategory[index];
    if (menu.list.includes(route.name)) {
      categoryName = menu.name;
      break;
    }
  }
  return categoryName;
}

/**
 * @description 같은 메뉴 카테고리인지 판단, 상단 메뉴에서 route-link로 이동시에,
 * from의 route는 null이므로 menuCategory내부 리스트와 비교 필요 없음
 * @param { Object } to
 * @param { Object } from
 * @returns { Boolean }
 */
export default function boolResetStore(to, from) {
  const toRouteName = getCategoryName(to);
  const fromRouteName = getCategoryName(from);
  if (toRouteName === null || fromRouteName === null) {
    return true;
  }
  return (toRouteName !== fromRouteName);
}



// WEBPACK FOOTER //
// ./src/components/customized-components/boolResetStore.js